const Pagination = require('tui-pagination');

let defaultVisiblePages = 6;
const defaultItemsViews = 6;

export default class PaginationClass {

  constructor(selector, url, callback ) {
    this.selector = document.querySelector(selector);
    this.url = url;
    this.callback = callback;
    this.urlParam = window.location.search;
    this.pagination;
  }

  init() {
    if((window.innerWidth * window.devicePixelRatio <= 768 * window.devicePixelRatio )) {
      defaultVisiblePages = 3;
    }
    if(!this.selector) return;
    let total = this.selector.getAttribute('data-total');
    let itemsView = this.selector.getAttribute('data-items');

    //Fallback
    if(itemsView == null || itemsView.length === 0){
      itemsView = defaultItemsViews;
    }

    this.pagination = new Pagination(this.selector, {
      totalItems: total,
      itemsPerPage: itemsView,
      visiblePages: defaultVisiblePages,
    });
    let that = this;
    this.pagination.on('beforeMove', function(eventData) {
      that.changePage(eventData.page);
    });
    if(this.urlParam.includes('currentPage')) {
      const urlSearchParams = new URLSearchParams(this.urlParam);
      const currentPage = urlSearchParams.get('currentPage')
      this.pagination.movePageTo(currentPage);
      this.changePage(currentPage);
    }
  }

  changePage(newPage){
    var callback = this.callback;
    var that = this;
    //Get default language
    var lang = $('html').attr('lang');
    lang = (lang == null) ? 'en' : lang;
    window.dispatchEvent( new Event('pagination.changed') );
    $.ajax({
      url: this.url,
      type: 'POST',
      data: {
        "page": newPage,
        "page-number": newPage,
        "userLang": lang,
      },
      complete: function (response) {
        window.dispatchEvent( new Event('pagination.changed') );
        window.scrollTo({top: 0, behavior: 'smooth'});
        callback(JSON.parse(response.responseText));
        that.changeUrlParameter();
      }
    });
  }
  changeUrlParameter(){
    //Replace the url
    window.history.replaceState(null, null, "?currentPage="+this.pagination.getCurrentPage());
    //Adjust the change lang href
      const newHref = window.location.href;
      const arrayOfTheHref = newHref.split('/')
      const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
      if(lang === 'en'){
        arrayOfTheHref[3] = 'fr';
      } else {
        arrayOfTheHref[3] = 'en';
      }
      const newUrl = arrayOfTheHref[3]+'/'+arrayOfTheHref[4]
      document.querySelector('#switchLang').href = arrayOfTheHref.join('/');
  }
}

